module.exports = __webpack_public_path__ + "img/spencer-signature.2a5cde34.png";